/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../nb');
var InputGroup = require('../../../view/form/InputWithLabel');
var Button = require('../../../view/Button');
module.exports = nb.define({
    view: {
        'class': 'form-content',
        $html: [{
            $type: InputGroup,      //账号
            $model: 'idNum'
        }, {
            $type: InputGroup,     //密码
            $model: 'password'
        }, {
            $name: 'submit',
            $type: Button,        //登录
            $model: 'button'
        }]
    },
    method: {
        init: function () {
            var self = this;

            // //忘记密码
            // this.$('forget-password').on('click', function () {
            //     var modal = require('../../../model/modal/retrievePassword/RetrievePassword');
            //     modal.set('show', new Date());
            // });

            this.$('submit').$().on('click', function () {
                self.getModel().set('submitLogin');
            });
        },
        onModelReady: function (inModel) {
            var self = this;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/login/view/Form.js
// module id = 161
// module chunks = 6 32